import type { InsightItem, InsightsSummary } from "@aura/shared";
import { capitalize, countWord } from "~/lib/format";

/** Headline from the severity tally. Deterministic, no model. */
export function buildInsightsHeadline(s: InsightsSummary): string {
  if (s.total === 0) return "Nothing needs your attention this period";
  const lead = `${capitalize(countWord(s.total))} ${s.total === 1 ? "finding needs" : "findings need"} attention`;
  if (s.critical > 0) {
    return `${lead}, ${countWord(s.critical)} of ${s.total === 1 ? "it" : "them"} critical`;
  }
  if (s.warning > 0) {
    return `${lead}, none critical`;
  }
  return `${capitalize(countWord(s.total))} ${s.total === 1 ? "thing is" : "things are"} worth a look, none urgent`;
}

/** One or two sentences naming the top finding and the categories hit. */
export function buildInsightsDek(items: InsightItem[]): string {
  if (items.length === 0) {
    return "No stale PRs, review pileups, failure spikes, idle seats or sprints at risk.";
  }
  const top = items[0]!;
  const cats = Array.from(new Set(items.map((i) => i.category)));
  const catText =
    cats.length === 1
      ? cats[0]!
      : `${cats.slice(0, -1).join(", ")} and ${cats[cats.length - 1]}`;
  const title = top.title.replace(/[.\s]+$/, "");
  return `Top of the list: ${title}. The findings touch ${catText}.`;
}
